import {ShouldSkipLazyLoadFn} from 'app/interface';

export const getShouldSkipLazyLoadFn = (moduleName: string, location: 'components' | 'modules' = 'components'): ShouldSkipLazyLoadFn => {
    if (process.env.NODE_ENV === 'test') {
        return () => 'LOAD_EAGER';
    }

    switch (location) {
        case 'components':
            return require(`app/components/${moduleName}/shouldSkipLazyLoad`).shouldSkipLazyLoad;

        case 'modules':
            return require(`modules/${moduleName}/shouldSkipLazyLoad`).shouldSkipLazyLoad;
    }
};
